import {PessoaSisbi} from '../sisbi/pessoa-sisbi';
import {EnderecoSisbi} from '../sisbi/endereco-sisbi';

export class FornecedorSgsia {
    idFornecedor: number;
    arquivosFornecedor?: any;
    tipoFornecedorEnum: number;
    idSolicitacao: number;
    pessoa: PessoaSisbi;
    nmProprietario: string;
    idPessoa: number;
    endereco: EnderecoSisbi;
    idTelefone: number;
    idEndereco: number;
    telefone: TelefoneSgsia;
    email: EmailSgsia;
    idEmail: number;
    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): FornecedorSgsia {
        if (jsonData.pessoa != null) {
            jsonData.pessoa = PessoaSisbi.fromJson(jsonData.pessoa);
        }
        if (jsonData.endereco != null) {
            jsonData.endereco = EnderecoSisbi.fromJson(jsonData.endereco);
        }
        if (jsonData.telefone != null) {
            jsonData.telefone = TelefoneSgsia.fromJson(jsonData.telefone);
        }
        if (jsonData.email != null) {
            jsonData.email = EmailSgsia.fromJson(jsonData.email);
        }
        return Object.assign(new FornecedorSgsia(), jsonData);
    }
}

class TelefoneSgsia {
    idTelefone: number;
    nrTelefone: string;
    idTipoTelefone: number;
    idPessoa: number;
    nrRamal: string;
    cdDdd: number;
    sgPais: string;
    csPrincipal: string;

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): TelefoneSgsia {
        return Object.assign(new TelefoneSgsia(), jsonData);
    }
}

class EmailSgsia {
    idEmail: number;
    idTipoEmail: number;
    idPessoa: number;
    edEmail: string;
    csPrincipal: string;
    dsTipoEmail: string;

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): EmailSgsia {
        return Object.assign(new EmailSgsia(), jsonData);
    }
}
